import { Box, Grid, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import logoIcon from "../../../assets/images/trunk_1.png";

const StorageJobPrint = () => {
  const { leadDetails } = useSelector((state: any) => state.lead);

  const customerName = leadDetails?.lead?.customer_name || "";
  const ref = leadDetails?.lead?.generated_id || "";

  // Create numbers 1–300
  const numbers = Array.from({ length: 300 }, (_, i) => i + 1);

  const rows = [];
  for (let i = 0; i < numbers.length; i += 10) {
    rows.push(numbers.slice(i, i + 10));
  }

  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
        fontSize: "13px",
      }}
    >
      {/* HEADER */}
      <Grid container alignItems="center">
        <Grid item xs={6}>
          <Typography fontWeight={600}>
            Trunk Logistics International
          </Typography>
        </Grid>

        <Grid item xs={6} textAlign="right">
            <Box display="flex" alignItems="center" justifyContent="flex-end">
                <img src={leadDetails?.company?.logo ?? logoIcon} alt="Trunk Logo" style={{ height: "50px" }} />
            </Box>
          {/* <Typography fontWeight={700} fontSize="22px">
            <img src={logoIcon} alt="Trunk Logo" style={{ height: "50px" }} />
            TRUNK
          </Typography>
          <Typography fontSize="12px">LOGISTICS</Typography> */}
        </Grid>
      </Grid>

      {/* CUSTOMER INFO */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              Customer name: {customerName}
            </TableCell>

            <TableCell sx={cell}>
              Ref: {ref}
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell} colSpan={2}>
              Date:
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* NUMBER GRID */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i}>
              {row.map((num) => (
                <TableCell key={num} sx={gridCell}>
                  {num}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* DAMAGE / SIGNATURE SECTION */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} width="50%">
              Damage:
            </TableCell>

            <TableCell sx={cell}>
              Discrepancies:
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>
              Crew Leader:
            </TableCell>

            <TableCell sx={cell}>
              Signature:
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>
              Date Signed:
            </TableCell>

            <TableCell sx={cell}></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default StorageJobPrint;

const cell = {
  border: "1px solid black",
  padding: "6px",
  fontSize: "13px",
};

const gridCell = {
  border: "1px solid black",
  textAlign: "center",
  padding: "4px",
  fontSize: "12px",
};